import React, { useEffect, useState } from "react";
import classNames from "classnames";
import TopNavRightSideNavItem from "./TopNavRightSideNavItem";
import { useToast } from "./store/toasterStore";
import Toaster from "../Toaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MinimalBackButton from "./MinimalBackButton";
import { currentUser } from "modules/utilities/utility";
import AgentDetailModal from "./AgentDetailModal";
import SpotlightSearch from "./SpotlightSearch";
import { POP_ACCESS } from "modules/utilities/utility_2";
import useLayoutMode from "hooks/useLayoutMode";
import RevampProductsButton from "modules/revamp_products/components/RevampProductsButton";
import "./NavbarTop.css";

const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
const shortcutKey = isMac ? "\u2318F" : "Ctrl+F";

const NavbarTop = () => {
  const layoutMode = useLayoutMode();
  const isMinimal = layoutMode === "minimal";
  const [showDropShadow, setShowDropShadow] = useState(false);
  const { title, message, variant } = useToast();

  useEffect(() => {
    const onScroll = () => {
      setShowDropShadow(document.documentElement.scrollTop > 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={classNames("topbar", {
        "topbar--shadow": showDropShadow && !isMinimal,
      })}
    >
      {/* ── Left: Tip + Toaster ── */}
      <div className="topbar__left">
        {isMinimal ? (
          <MinimalBackButton />
        ) : (
          <>
            <div
              className="topbar__search-bar"
              onClick={() => window.dispatchEvent(new CustomEvent("open-spotlight"))}
            >
              <FontAwesomeIcon icon="search" className="topbar__search-bar-icon" />
              <span className="topbar__search-bar-text">Search pages, tabs & people...</span>
              <kbd className="topbar__search-bar-kbd">{shortcutKey}</kbd>
            </div>
            <Toaster title={title} message={message} variant={variant} />
          </>
        )}
      </div>

      {/* ── Right: Actions + Profile ── */}
      {isMinimal && (
        <div className="topbar__right">
          <RevampProductsButton />
        </div>
      )}
      {!isMinimal && <TopNavRightSideNavItem />}

      {!POP_ACCESS.includes(currentUser) && <AgentDetailModal />}
      <SpotlightSearch />
    </div>
  );
};

export default NavbarTop;
